export const editActions = <const>{
	ND_SKLAD_POLOZKY_MAPPER: 'ND_SKLAD_POLOZKY_MAPPER',
};
export const editMutations = <const>{
	ND_SKLAD_POLOZKY_MAPPER: 'ND_SKLAD_POLOZKY_MAPPER',
};
